/* eslint-env browser */
import { StatefulLoader, Collapsable } from '@mauriceguest/guest'
import LoginFormController from './LoginFormController'

// not exported
// export default class LoginFormComponent {
//   render(props) {
//     const { el } = this
//     LoginFormController.control(el, { props })
//   }
//   constructor(el, parent) {
//     this.el = el
//   }
// }
// LoginFormComponent['plain'] = true

export { LoginFormController }

/** @constructor @extends {LoginFormController} @suppress {checkTypes} */ function _LoginFormController() {}
LoginFormController.__implement(StatefulLoader, Collapsable,
 _LoginFormController.prototype = /** @type {!LoginFormController} */ ({
  ready() {
   const { PhoneInput, PasswordInput } = this
   PhoneInput.addEventListener('input', () => {
    this.userLoader.resetLoadingState()
   })
   PasswordInput.addEventListener('input', () => {
    this.userLoader.resetLoadingState()
   })
  },
  async signIn() {
   const {
    asIStateful: { setState },
    asIUserLoaderer:{userLoader},
    LoginForm,
   } = this
   const isValid = LoginForm.reportValidity()
   if (!isValid) return
   const user = await userLoader.SignIn(LoginForm)
   if(user) {
    setState({
     success:true,
    })
    this.dispatchEvent(new Event('signin'))
    window.dispatchEvent(new Event('signin'))
   }
   // can return data about the user here actually
  },
  paint() {
   const {
    userLoader:{state:{errorText}},
    state: {success}, LoginError, LoginSuccess,
   } = this

   if(errorText) LoginError.innerHTML = errorText
   else LoginError.innerText = ''

   if(success) LoginSuccess.innerText = 'Успех!'
   else LoginSuccess.innerText = ''
  },
 }),
)